import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

import sx from '../../internal/styles/sx';

const StyledInput = styled('input', { shouldForwardProp })(
  css({
    pt: 5,
    pb: 2,
    px: 3,
    boxSizing: 'border-box',
    border: 'none',
    fontSize: 'input.text',
    lineHeight: 'input',
    'html[dir=ltr] &': {
      textAlign: 'left',
    },
    'html[dir=rtl] &': {
      textAlign: 'right',
    },
    width: '100%',
    background: 'none',
    outline: '0',
    '&::placeholder': {
      visibility: ['hidden', 'visible'],
    },
    '&::-webkit-inner-spin-button, &::-webkit-calendar-picker-indicator, &::-webkit-clear-button':
      {
        display: 'none',
        appearance: 'none',
      },
    '&:-webkit-autofill': {
      // This removes the styles in -webkit- browsers on autofill
      WebkitBackgroundClip: 'text',
    },
    textOverflow: 'ellipsis',
  }),
  sx
);

export default StyledInput;
